<template>
    <div class="d-sm-flex justify-content-center" v-if="active">
        <div class="alert" id="app-alert" :class="type" role="alert">{{ message }}</div>
    </div>
</template>

<script>
    export default {
    	name: "alert",
        
        data() { 
            return { 
                active: false,
                message: "",
                type: "",
            }
        },

        methods: {
            alert(message, type) {
                this.message = message;
                this.type = type;
                this.active = true;

                setTimeout( () => this.active = false, 3000);
            }
        }
    }
</script>
